import { Annotation } from "../../../../domain/entities/entities";
import { interfaceAnnotationUseCase } from "../../../../domain/usecase/impl/annotationUseCases";
import { ActionContext } from "vuex";

class AnnotationState {
  annotations: Array<Annotation> = Array<Annotation>();
  timestamp: number = NaN;
  redirectTo: number = NaN;
  videoPauseRequested: boolean = false;
}

const state = new AnnotationState();
const mutations = {
  LOAD_NOTE_LIST: (state: AnnotationState, annotations: Array<Annotation>) => {
    state.annotations = annotations;
    state.annotations.sort(function(a, b) {
      return a.seconds - b.seconds;
    });
  },
  SET_TIMESTAMP: (state: AnnotationState, timestamp: number) => {
    state.timestamp = timestamp;
  },
  REDIRECT_TO_TIMESTAMP: (state: AnnotationState, targetTimestamp: number) => {
    state.redirectTo = targetTimestamp;
  },
  TOGGLE_VIDEO_STATE: (state: AnnotationState, formState) => {
    if (formState == false) {
      state.videoPauseRequested = true;
    } else if (formState == true) {
      state.videoPauseRequested = false;
    }
  },
  ADD_NEW_ANNOTATION: (state: AnnotationState, annotation: Annotation) => {
    state.annotations.push(annotation);
    state.annotations.sort(function(a, b) {
      return a.seconds - b.seconds;
    });
  },
  REMOVE_ANNOTATION: (state: AnnotationState, annotation: Annotation) => {
    const index = state.annotations.indexOf(annotation);
    state.annotations.splice(index, 1);
  }
};
const actions = {
  async loadAnnotations(
    { commit }: ActionContext<AnnotationState, AnnotationState>,
    content_id: number
  ): Promise<Annotation[]> {
    const annotations: Array<Annotation> = await interfaceAnnotationUseCase.listAnnotations(
      content_id
    );
    commit("LOAD_NOTE_LIST", annotations);
    return annotations;
  },

  redirectToTimestamp(
    { commit }: ActionContext<AnnotationState, AnnotationState>,
    timestamp: number
  ): void {
    commit("REDIRECT_TO_TIMESTAMP", timestamp);
  },

  changeVideoState(
    { commit }: ActionContext<AnnotationState, AnnotationState>,
    formState: boolean
  ): void {
    commit("TOGGLE_VIDEO_STATE", formState);
  },

  async editAnnotation(
    { commit }: ActionContext<AnnotationState, AnnotationState>,
    annotation: Annotation
  ): Promise<void> {
    await interfaceAnnotationUseCase.editAnnotation(annotation);
  },

  async saveAnnotation(
    { commit }: ActionContext<AnnotationState, AnnotationState>,
    payload: any
  ): Promise<Annotation> {
    const annotation: Annotation = await interfaceAnnotationUseCase.saveAnnotation(
      payload
    );
    commit("ADD_NEW_ANNOTATION", annotation);
    return annotation;
  },

  async removeAnnotation(
    { commit }: ActionContext<AnnotationState, AnnotationState>,
    annotation: Annotation
  ): Promise<void> {
    await interfaceAnnotationUseCase.deleteAnnotation(annotation);
    commit("REMOVE_ANNOTATION", annotation);
  },

  async recoverPassword(
    { commit }: ActionContext<AnnotationState, AnnotationState>,
    annotation: Annotation
  ): Promise<void> {
    await interfaceAnnotationUseCase.deleteAnnotation(annotation);
    commit("REMOVE_ANNOTATION", annotation);
  },

  setTimestamp(
    { commit }: ActionContext<AnnotationState, AnnotationState>,
    timestamp: number
  ): void {
    commit("SET_TIMESTAMP", timestamp);
  }
};
const getters = {
  annotations: state => state.annotations,
  redirectTo: state => state.redirectTo,
  timestamp: state => state.timestamp,
  videoPauseRequested: state => state.videoPauseRequested
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
